import { createFileRoute, useNavigate } from '@tanstack/react-router';
import * as React from 'react';
import { PERMISSION_GDPR_PROFILE_LIST } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';
import GdprProfileHistoryDetail from '../../components/GdprProfile/HistoryDetail';
import { GDPR_PROFILE_HISTORY_URL } from '../../components/GdprProfile/constants';

export const Route = createFileRoute('/_authenticated/gdpr-profile/history/edit/$id')({
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_GDPR_PROFILE_LIST, ['read'], '/unauthorized', context);
    return {
      ...context,
      documentTitle: {
        main: 'gdprProfile.modal.changeDetail.title',
        suffix: 'tab.gdpr/profile/history',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: GdprProfileHistoryDetailRoute,
});

function GdprProfileHistoryDetailRoute() {
  const { id } = Route.useParams();
  const navigate = useNavigate();

  const handleClose = React.useCallback(() => {
    navigate({ to: GDPR_PROFILE_HISTORY_URL });
  }, [navigate]);

  return <GdprProfileHistoryDetail closeCallback={handleClose} id={Number(id)} />;
}
